import { Service } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Service()
export class LoadingService {
    private blockCounter: number = 0;
    private logging: boolean = false;
    private blockTimer: number | null = null;

    private _blockingWatch = new BehaviorSubject<number>(0);
    public isBlocked(): Observable<number> {
        return this._blockingWatch;
    }

    inc(from: string): void {
        if (this.logging) { console.log('inc ' + from + ' ' + this.blockCounter); }
        this.blockCounter++;

        if (!this.blockTimer) {
            this.blockTimer = window.setTimeout(() => {
                this._blockingWatch.next(this.blockCounter);
            }, 250);
        }

    }

    dec(from: string): void {
        if (this.logging) { console.log('dec ' + from + ' ' + this.blockCounter); }
        this.blockCounter--;
        this._blockingWatch.next(this.blockCounter);
        if (this.blockCounter == 0) {
            if (this.blockTimer) {
                window.clearTimeout(this.blockTimer);
                this.blockTimer = null;
            }
        }
    }

}
